import React from "react";
import Chart from "react-apexcharts";
import { COLOR_VENTAS, COLOR_VENTAS_ANTERIOR } from "./constants";
import { formatCurrency } from "./utils";

export default function GraficoVentasComparativo(props) {
    const moneda = props.moneda || "PEN";
    const timeLine = props.timeLine || [];
    const actual = props.actual || [];
    const anterior = props.anterior || [];
    const valorMaximo = Math.max(0, ...actual, ...anterior);

    const options = {
        chart: {
            type: "line",
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        colors: [COLOR_VENTAS, COLOR_VENTAS_ANTERIOR],
        // Periodo actual: linea continua con relleno. Periodo anterior:
        // linea punteada sin relleno.
        stroke: { width: [3, 2], curve: "straight", dashArray: [0, 5] },
        fill: { type: "solid", opacity: [0.12, 1] },
        dataLabels: { enabled: false },
        markers: { size: 0 },
        xaxis: {
            categories: timeLine,
            tickAmount: 6,
            labels: { rotate: 0, hideOverlappingLabels: true },
            tooltip: { enabled: false },
        },
        yaxis: {
            min: 0,
            // Sin ventas en ninguno de los dos periodos se fija una escala
            // para que el grafico pinte sus ejes con la linea en 0.
            max: valorMaximo > 0 ? undefined : 100,
            tickAmount: 5,
            labels: {
                // Con montos chicos (< 1000) dividir entre 1000 siempre da "0K";
                // en ese caso se muestra el numero tal cual.
                formatter: (val) => (val >= 1000 ? `${Math.round(val / 1000)}K` : `${Math.round(val)}`),
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (val) => formatCurrency(val, moneda),
            },
        },
        legend: {
            position: "top",
            horizontalAlign: "center",
        },
        grid: { borderColor: "#eef0f2" },
    };

    const series = [
        { name: props.nombreActual || "Este mes", type: "area", data: actual },
        { name: props.nombreAnterior || "Mes anterior", type: "line", data: anterior },
    ];

    // react-apexcharts compara las options con JSON.stringify, que ignora las
    // funciones: la key obliga a remontar cuando cambia la moneda (tooltip).
    return (
        <Chart key={moneda} options={options} series={series} type="line" height={300} />
    );
}
